import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzq38g3qv7: FaireProductEntity = {
  token: "p_zzq38g3qv7",
  type: "product",
  name: "Zen Buddha Sand Garden",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl: "https://cdn.faire.com/fastly/81f0980f0949a9e235bdb84b02264c4e897f73d6f2a71b3a275cfd28c17b2d1b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a1b6bda3202f4c32b5d9ab62b4967234d2022be8d3f965dc84b057e484a80f8.jpeg",
    "https://cdn.faire.com/fastly/76784fb9aefc7ce8667a5a0d19fbbaa9c1ffa1fad2c8ca96d4f1e1125642ee23.jpeg",
    "https://cdn.faire.com/fastly/dafaa917a325f6a2919d58bf1df446ebb4a09cc1e0ef08a4fca9a55a00d0f8e0.jpeg",
    "https://cdn.faire.com/fastly/f3bd5a7cfd29d20576aa9dbd0daaf3a4fb52f57a1ff3bbb130e107ea133e9c99.jpeg",
    "https://cdn.faire.com/fastly/e4647a5ec679aa7d762652b91db673d2dd964f443eaca24aeb2aad8fc09c7d3b.jpeg"
  ],
  priceDollars: 9.01,
  description: "Zen Buddha Sand Garden\nProduct Size:  12.5\" X 7.8\" X 3.12\nMaterial: Cold Cast Resin\nCase Pack: 32\nCandles not included",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:24.358Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
